import { render, staticRenderFns } from "./Employees-Show.vue?vue&type=template&id=2035dcd8&scoped=true&"
import script from "./Employees-Show.vue?vue&type=script&lang=js&"
export * from "./Employees-Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035dcd8",
  null
  
)

export default component.exports